// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"e6f96195","162":"8e8006e8","192":"66b113b9","400":"2704945e"}[chunkId] + ".chunk.js";
};